import { GuidedScene } from "../GuidedScene";
import { Sound, SoundCard } from "../SoundCard";
import { fetchAttributionAsync } from "../global";

export const CONTENT_HOSTILE_LICENSE_NAMES = [
    "FB Special License",
    "Soundsmith",
]
function isForbiddenContent(attribution: any): boolean {
    return CONTENT_HOSTILE_LICENSE_NAMES.includes(attribution.License.Name);
}
function isAllowedContent(attribution: any): boolean {
    return !isForbiddenContent(attribution);
}

export async function calculateCopyrightNotice(scene: GuidedScene): Promise<CopyrightNotice> {

    const soundsByAuthor: { [index: string]: Sound[] } = {}
    const attributionsByAuthor = {}
    async function handleCard(card: SoundCard): Promise<void> {
        const sound = card.sound;
        const attribution = await fetchAttributionAsync(sound.id);
        if (attribution == null) {
            return;
        }
        attributionsByAuthor[attribution.Author.Name] = attribution;
        if (!(attribution.Author.Name in soundsByAuthor)) {
            soundsByAuthor[attribution.Author.Name] = [];
        }

        soundsByAuthor[attribution.Author.Name].push(sound);
    }

    await Promise.all(scene.AllCards().map(handleCard));

    const usableSoundNotice = Object.entries(soundsByAuthor)
        .filter(entry => isAllowedContent(attributionsByAuthor[entry[0]]))
        .map(entry => {
            const authorName: string = entry[0];
            const sounds: Sound[] = entry[1];
            const attribution = attributionsByAuthor[authorName];

            const soundList = [...new Set(sounds.map((sound) => `"${sound.name}"`))].join(", ")
            return `${soundList} by ${authorName} (${attribution.Author.Url}), ${attribution.License.Name}`
        }).join("\n");

    const unusableSoundsNotice = Object.entries(soundsByAuthor)
        .filter(entry => isForbiddenContent(attributionsByAuthor[entry[0]]))
        .map(entry => {
            const authorName: string = entry[0];
            const sounds: Sound[] = entry[1];
            const soundList = [...new Set(sounds.map((sound) => `"${sound.name}"`))].join(", ")
            return `${soundList} by ${authorName} CANNOT be used in public productions.`
        }).join("\n")

    return {
        usableSoundNotice,
        unusableSoundsNotice,
    }
}

export type CopyrightNotice = {
    usableSoundNotice: string,
    unusableSoundsNotice: string | null,
}